export class PermissionTemplate {
  id: number = 0;
  name: string = '';
  description: string = '';
  appId: number = 0;
  status: number = 0;
  subscriptionCount: number = 0;
  createdAt: Date = new Date();
  permissions: PermissionTemplatePermission[] = [];
}

export class PermissionTemplatePermission {
  id: number = 0;
  permissionId: number = 0;
  permissionName: string = '';
}
